// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"624da8ef","359":"f7fd6d1c","453":"d855a71b","457":"278dbe7e","479":"77b3aeab","719":"a370d48b","773":"f68a08c7","947":"8d0911bd","970":"b8ac57df"}[chunkId] + ".chunk.js";
};